import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, ArrowLeft, KeyRound, CheckCircle2, Loader2 } from 'lucide-react';
import { BRAND } from '../mock/mock';
import { api } from '../lib/api';

const RecruiterForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post('/recruiter/forgot-password', { email });
      setSent(true);
    } catch {
      setSent(true); // always succeed-silent to avoid enumeration
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen relative overflow-hidden flex items-center py-12">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#f7fbf3] via-[#fdfaf1] to-[#f4f9ef]" />
        <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-[#F0B93C]/15 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#0B5E2A]/15 blur-3xl" />
      </div>
      <div className="max-w-md mx-auto container-px w-full">
        <Link to="/recruiter/login" className="inline-flex items-center gap-2 text-sm font-medium text-[#4b5e4d] hover:text-[#0B5E2A] mb-5 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to login
        </Link>
        <div className="bg-white border border-[#0B5E2A]/10 rounded-2xl p-8 shadow-[0_20px_50px_-25px_rgba(11,94,42,0.25)]">
          <div className="text-center">
            <div className="mx-auto h-14 w-14 rounded-full bg-brand-gold flex items-center justify-center">
              <KeyRound className="h-7 w-7 text-[#06401d]" />
            </div>
            <h1 className="mt-4 font-display text-2xl text-[#0B5E2A]">Forgot Password?</h1>
            <p className="mt-2 text-sm text-[#4b5e4d]">{BRAND.name} · Recruiter Portal</p>
          </div>
          {sent ? (
            <div className="mt-6 text-center">
              <CheckCircle2 className="h-10 w-10 mx-auto brand-green" />
              <div className="mt-3 font-display text-lg text-[#0B5E2A]">Check your email</div>
              <p className="mt-2 text-sm text-[#4b5e4d]">If an account exists for <span className="font-semibold">{email}</span>, you'll receive a password reset link within a minute. The link is valid for 30 minutes.</p>
              <Link to="/recruiter/login" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0B5E2A] hover:underline">
                <ArrowLeft className="h-4 w-4" /> Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <p className="text-sm text-[#4b5e4d]">Enter the email associated with your recruiter account. We'll send a password reset link.</p>
              <div>
                <label className="block text-sm font-medium text-[#2e4030] mb-1.5">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#6b7e6d]" />
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full pl-10 pr-3 py-2.5 rounded-md border border-[#0B5E2A]/20 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B5E2A]/30" />
                </div>
              </div>
              <button type="submit" disabled={busy} className="btn-green w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md disabled:opacity-60">
                {busy ? (<><Loader2 className="h-4 w-4 animate-spin" /> Sending...</>) : (<>Send Reset Link <ArrowRight className="h-4 w-4" /></>)}
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
};

export default RecruiterForgotPassword;
